import type { Route } from '@angular/router';

export const appRoutes: Route[] = [];
